// extracted by mini-css-extract-plugin
module.exports = {"setupRelation":"Action_setupRelation__33_0W","root":"Action_root__3oURz"};